import { ModelEvents } from "@denishussar/html5-game-engine"
import { getCommonConfig } from "../../Common/GameConfig";
import { sampleFromArray } from "../../Common/Utils";
import { GeneratorEvenets } from "../../Constants/Events";
import { GameModel, GameMoveableObstacleTypeEnum, GameObstacleTypeEnum, GenObstacleEnum } from "../../Models/GameModel"
import { IGenParams } from "../../Utils/AbstractGenerator/AbstractGenerator"
import { Entity } from "../../Utils/AbstractGenerator/Entity"
import { Random } from "../../Utils/Math";

export class LowEntity implements Entity {
    // private obstacleDistance: number;
    private obstacles = [
        // GameObstacleTypeEnum.stone,
        // GameObstacleTypeEnum.hole,
        GameMoveableObstacleTypeEnum.golf,
        GameMoveableObstacleTypeEnum.hummer,
    ]
    private previous = GameObstacleTypeEnum.none;
    constructor(
        private model: GameModel,
        private events: ModelEvents,
    ) {
        // this.obstacleDistance = getCommonConfig('obstacleDistance');
    }

    usefulness() {

        return <IGenParams>{ low: 1, med: 0, high: 0 }
    }

    spawn() {
        const lastGenerated = this.model.generator.generated[this.model.generator.generated.length - 1];
        if (lastGenerated) {
            if (lastGenerated.type != GenObstacleEnum.med)
                if ((this.model.playerDistance - this.model.generator.lastObstacleDistance) < this.model.generator.obstacleDistance) return;
        }
        this.model.generator.lastObstacleDistance = this.model.playerDistance;

        let type = sampleFromArray(this.obstacles, 0);
        let road = 0;
        let roads = [-1, 0, 1];
        let lastRoad;
        // let lastCollectableRoad;
        try {
            lastRoad = this.model.generator.generated[this.model.generator.generated.length - 1].road;
        }
        catch {
            lastRoad = 2;
        }
        // try {
        //     lastCollectableRoad = this.model.generator.collectables[this.model.generator.collectables.length - 1].road;
        // }
        // catch {
        //     lastCollectableRoad = 2;
        // }

        console.log(lastRoad)

        roads = roads.filter(r => (r != lastRoad));

        // while (type == this.previous) {
        type = sampleFromArray(this.obstacles, 0);

        // }
        this.previous = type;
        switch (type) {
            // case GameObstacleTypeEnum.hole:
            //     road = Math.round(Random()) ? 1 : -1;
            //     // this.events.dispatch(this.model, GeneratorEvenets.addObstacle, GameObstacleTypeEnum.roadSign, road);
            //     // this.events.dispatch(this.model, GeneratorEvenets.addObstacle, type, road);
            //     // this.model.gameScreen.createObstacleController({type:GameObstacleTypeEnum.roadSign, roadIndex: road});
            //     this.model.gameScreen.createObstacleController({type:type, roadIndex: road});
            //     this.model.gameScreen.createObstacleController({type:GameObstacleTypeEnum.roadSign, roadIndex: road}, 100);
            //     break;
            default:
                roads = roads.filter(e => e != lastRoad)
                road = sampleFromArray(roads, 0);
                // this.events.dispatch(this.model, GeneratorEvenets.addObstacle, type, road);
                this.model.gameScreen.createMoveableObstacleController({ type: type, roadIndex: road });
                break;
        }
        this.model.generator.lastObstacleDistance = this.model.playerDistance;
        this.model.generator.generated.push({ type: GenObstacleEnum.low, distance: this.model.playerDistance, road, obstacleType: type })
    }

}